import type { Tenant } from "@/model/session";

import {
  isAuthenticated,
  login,
  loginPage,
  logout,
  refreshToken,
  refreshTokenGuarded,
} from "./api.config";

export default { isAuthenticated, logout, login, loginPage, refreshToken, refreshTokenGuarded };

export interface LoginRequest {
  email?: string;
  tenantId?: string;
  type?: string;
  path?: string;
  companyId?: string;
}

export interface LoginResponse {
  success: boolean;
  tenants?: Tenant[];
  redirectUrl?: string;
  error?: string;
}
